import React, { useEffect, useRef, useState } from "react";
import { get, post } from "../../../../Network/Axios";
import { useParams } from "react-router-dom";
import {
  Button,
  CheckBox,
  Headings,
  Input,
  Loader,
  SelectInput,
  Seperator,
  SidePane,
  Switch,
  Texts,
  TOAST,
} from "../../../../../retro";
import Bank from "./bank.png";
import useFunctionallityHook from "../../../../Hooks/useFunctionallityHook";
import { v4 } from "uuid";
export default function BulkPe() {
  const { id } = useParams();
  const NAME = useRef();
  const UDF1 = useRef();
  const UDF2 = useRef();
  const UDF3 = useRef();
  const TYPE = useRef();
  const OTHER = useRef();
  const [type,setType] = useState('upi')
  const [Modal, SetModal] = useState(false);
  const [btnLoader,setBtnLoader] = useState(false)
  const [BulkPeModel, setBulkPeModel] = useState(false);
  const [isWhitelistAccount, setisWhitelistAccount] = useState(false);
  const [ClientDetails, setClientDetails] = useState(undefined)
  const [WhitelistAccounts, setWhitelistAccounts] = useState([
      {
        name: "",
        accountNumber: "",
        ifsc: "",
      },
    ]);
  const [loading, setLoading] = useState(true);
  const MULTI = useFunctionallityHook().multiDeposit;
  const [details, setDetails] = useState();

  const load = () => {
    setLoading(true);
    get(`/bulkPe/get-va-V2/${id}`, (e, r) => {
      if (r) {
        setLoading(false);
        setDetails(r);
      }
    });
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(()=>{
      get(`/clients/${id}`, (e, r) => {
        if (r) {
          setClientDetails(r)
        }
      })
  },[id])

  function addBulkPe() {
      try {
        const gstinRegex = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
  
        const panPattern = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
   
        if(UDF1.current.value){
          if (!panPattern.test(UDF1.current.value)) {
            TOAST.error('Invalid PAN card number');
            return;
          }  
        }
              
        if(UDF2.current.value){
          if (!gstinRegex.test(UDF2.current.value)) {
            TOAST.error('Invalid GST number');
            return;
          }              
        }     
        if(!UDF1.current.value && !UDF2.current.value){
          TOAST.error('Please Enter GST or PAN Number');
          return
        }

        if(UDF2.current.value && UDF1.current.value){
          if (!UDF2.current.value.includes(UDF1.current.value)) {
            TOAST.error('Please Enter valid details');
            return
          }
          
        }

        let selectedType=type
        if(!selectedType){
          TOAST.error("Please select the type")
          return;
        }

        if(selectedType==="other"){
          if(!OTHER.current.value){
            TOAST.error("Please enter the type name")
            return;
          }
          else{
            selectedType=OTHER.current.value
          }
        }


             
         
        let data = {
          name: NAME.current.value,
          settleTo: "PARENT",
          referenceId: v4(), // base64
          ...(UDF1?.current?.value)?{udf1: UDF1.current.value}:{},
          ...(UDF2?.current?.value)?{udf2: UDF2.current.value}:{},
          udf3: UDF3.current.value,
          isWhitelistAccount: isWhitelistAccount, //
          WhitelistAccounts: [],
          type:selectedType
        };
        if (isWhitelistAccount) {
          data.WhitelistAccounts = WhitelistAccounts;
        }
        setBtnLoader(true)
          post(
            `/bulkPe/create-va-v2/${id}`,
            data,
            (e, r) => {
              if (r) {
  
                if(!r.status){
                  setBtnLoader(false)
                  TOAST.error(JSON.stringify(r?.message));
                  return
  
  
                }else{
                  setBulkPeModel(false)
                  load()
                  TOAST.success("Bulkpe add successfully");
                }
                setBtnLoader(false)
              }
              else if(e){
                TOAST.handleError(e)
                setBtnLoader(false)
              }
            }
          );
  
          
      } catch (error) {
        setBtnLoader(false)
  
        console.log(error);
      }
    }



  function updateBulkPe() {
    try {

      const gstinRegex = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
  
        const panPattern = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
   
        if(UDF1.current.value){
          if (!panPattern.test(UDF1.current.value)) {
            TOAST.error('Invalid PAN card number');
            return;
          }  
        }
              
        if(UDF2.current.value){
          if (!gstinRegex.test(UDF2.current.value)) {
            TOAST.error('Invalid GST number');
            return;
          }              
        }     
        if(!UDF1.current.value && !UDF2.current.value){
          TOAST.error('Please Enter GST or PAN Number');
          return
        }

        if(UDF2.current.value && UDF1.current.value){
          if (!UDF2.current.value.includes(UDF1.current.value)) {
            TOAST.error('Please Enter valid details');
            return
          }
          
        }
     
      
      
      let data = {
        name: NAME.current.value,
        settleTo: "PARENT",
        vaId: Modal?.vaId, // base64
        udf1: UDF1.current.value,
        udf2: UDF2.current.value,
        udf3: UDF3.current.value,
        
      
      };
      setBtnLoader(true)
        post(
          `/bulkPe/update-va/${id}/${Modal?.id}`,
          data,
          (e, r) => {
            if (r) {


              if(!r.status){
                TOAST.error(JSON.stringify(r?.message));
                setBtnLoader(false)
                return


              }else{

                TOAST.success(r?.message);
                setBtnLoader(false)

              }
              SetModal(false)
              load();
            }
            else if(e){
              TOAST.handleError(e);
              setBtnLoader(false)
            }
          }
        );

        
    } catch (error) {
      console.log(error);
      setBtnLoader(false)
    }
  }


  if (loading) {
    return <Loader />;
  }



  let mapItem=(details,index)=>{
    return <div
        onClick={() => {
          // HISTORY.push(`/app/accounts/${id}/${item.id}`)
        }}
        key={index}
        className="retro-card"
      >
        <div className="flex flex-1 justify-end"  >

        <Switch
          state={details?.active}
          onChange={(e) => {
            post(
              `/bulkPe/toggle-va/${id}`,
              {
                vaId: details?.vaId,
                isActive: e,
              },
              (e, r) => {
                if (r) {
                  load()
                  TOAST.success(r?.message);
                }
              }
            );
          }}
          size="large"
        />
        </div>

        <Headings.Regular>{details?.name}</Headings.Regular>
        <div className="mb3 mt3">
          <Texts.Regular>{details?.account}</Texts.Regular>
          {(details?.ifsc)?<Texts.Light>IFSC : {details?.ifsc}</Texts.Light>:null}
          {(details?.udf1)?<Texts.Light>PAN : {details?.udf1}</Texts.Light>:null}
          {(details?.udf2)?<Texts.Light>GSTIN : {details?.udf2}</Texts.Light>:null}
          {(details?.udf3)?<Texts.Light>Others : {details?.udf3}</Texts.Light>:null}
          {(details?.vaId)?<Texts.Light>VA ID : {details?.vaId}</Texts.Light>:null}
          {(details?.type)?<Texts.Light>Type : {details?.type}</Texts.Light>:null}
        </div>
        <Headings.Small>INR {details?.balance}</Headings.Small>
        <div className="flex flex-1 justify-end" >
          <i  onClick={()=>{
          SetModal(details)
          }} className="fa fa-edit"/>
        </div>
      </div>
  }



  return (
    <>

    {(window.location.href.includes("cockpit.dice.tech") || window.location.href.includes("localhost"))?<Button margin="" className="btn-primary mb4" onClick={()=>{
      setBulkPeModel(true)
    }}>
      + Add Account
    </Button>:null}
    {(details?.status && details?.diceAccounts?.length)?(
      <div className="card-container">
        {details.diceAccounts.map(mapItem)}
      </div>
    ):(
        <>
          <div style={{
            height:600
          }} className="center w-100 flex vertically">
            <img alt="bank" src={Bank} style={{
              height:250,
              width :250
            }}/>
            <Headings.Large>
              No Details Found 
            </Headings.Large>
            {/* <Texts.Regular>
              no virtual account found in repository
            </Texts.Regular> */}
          </div>

        </>
    )}
      
   



      {/* {
				!accounts.length &&
				<div style={{
					height:600
				}} className="center w-100 flex vertically">
					<img alt="bank" src={Bank} style={{
						height:250,
						width :250
					}}/>
					<Headings.Large>
						No virtual accounts
					</Headings.Large>
					<Texts.Regular>
						no virtual account found in repository
					</Texts.Regular>
				</div>
			} */}
      {
				Modal &&   <SidePane
                onClose={() => {
                  SetModal(undefined);
                }}
                description="Enter details below to update BulkPe"
                title="Update BulkPe"
                width={700}
              >
                <Input
                defaultValue={Modal?.name}
                disabled={true}
                ref={NAME} placeholder="Enter Name" label="Name *" />
                <Input ref={UDF1}
                defaultValue={Modal?.udf1}
                placeholder="Enter PAN Number" label="PAN Number" />
                <Input ref={UDF2}
                                defaultValue={Modal?.udf2}

                placeholder="Enter GST Number" label="GST Number" />
                <Input ref={UDF3}
                                defaultValue={Modal?.udf3}

                placeholder="Enter Others" label="Others " />
                <Button loading={btnLoader} onClick={updateBulkPe} className="btn-primary mt5">
                  Update Bulkpe
                </Button>
              </SidePane>
			}
      {BulkPeModel && (
          <SidePane
            onClose={() => {
              setBulkPeModel(undefined);
            }}
            description="Enter details below to add BulkPe"
            title="Add BulkPe"
            width={700}
          >
            <Input defaultValue={ClientDetails?.name} ref={NAME} placeholder="Enter Name" label="Name *" />
            <Input ref={UDF1} placeholder="Enter Pan Number" label="PAN Number" />
            <Input ref={UDF2} placeholder="Enter GST Number" label="GST Number" />
            <Input ref={UDF3} placeholder="Enter Others" label="Others " />
            <SelectInput onChange={() => {
              setType(TYPE.current.value)
            }} ref={TYPE} defaultValue={type} label="Select Type" options={[
              {
                label: "upi",
                value: 'upi'
              },
              {
                label: "payout",
                value: 'payout'
              },
              {
                label: "booking",
                value: 'booking'
              },
              {
                label: "utility",
                value: 'utility'
              },
              {
                label: "other",
                value: 'other'
              },
            ]}/>
            {
              type==="other"?<Input ref={OTHER} placeholder="Enter Type" label="Type " />:null
            }
            <CheckBox
              onChange={(checked) => {
                setisWhitelistAccount(checked);
              }}
              className="mt3 center-vertically"
              label="Whitelist Account"
            />
  
            <Seperator />
  
            {isWhitelistAccount && (
              <div>
                <div className="flex flex-1">
                  <div className="flex flex-1">
                    <div>Add Whitelist Account</div>
                  </div>
                  <div
                    className="flex flex-1 justify-end mr2"
                    onClick={() => {
                      setWhitelistAccounts((p) => {
                        return [
                          ...p,
                          {
                            name: "",
                            accountNumber: "",
                            ifsc: "",
                          },
                        ];
                      });
                    }}
                  >
                    <i className="fa fa-plus-circle fa-2x mr1" />
                  </div>
                </div>
  
                <div className="mt2">
                  <div className="flex flex-row">
                    <p className="flex-1">Name</p>
                    <p className="flex-1">IFC code</p>
                    <p className="flex-1">Account Number</p>
                  </div>
  
                  {WhitelistAccounts.map((i, index) => {
                    return (
                      <>
                        <div className="flex flex-row">
                          <Input
                            onChange={(e) => {
                              setWhitelistAccounts((p) => {
                                let newData = p;
                                newData[index].name = e;
                                return newData;
                              });
                            }}
                            label=""
                          />
                          <Input
                            className="ml2 mr2 mt1"
                            onChange={(e) => {
                              setWhitelistAccounts((p) => {
                                let newData = p;
                                newData[index].ifsc = e;
                                return newData;
                              });
                            }}
                            label=""
                          />
                          <Input
                            onChange={(e) => {
                              setWhitelistAccounts((p) => {
                                let newData = p;
                                newData[index].accountNumber = e;
                                return newData;
                              });
                            }}
                            label=""
                          />
  
                          <div
                            onClick={() => {
                              let LocalWhitelistAccounts = WhitelistAccounts;
  
                              LocalWhitelistAccounts =
                                LocalWhitelistAccounts.filter(
                                  (i, ind) => ind !== index
                                );
                              setWhitelistAccounts([...LocalWhitelistAccounts]);
                            }}
                          >
                            <i className="fa fa-trash  mt4 ml2" />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            )}
  
            <Button loading={btnLoader} onClick={addBulkPe} className="btn-primary mt5">
              Add Bulkpe
            </Button>
          </SidePane>
        )}
    </>
  );
}
